var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"selected-fridge"},[_vm._v(" Выбран холодильник: "+_vm._s(_vm.fridge)+" ")]),(!_vm.isHomePage)?_c('div',[_c('main-menu-button',{attrs:{"to":"/"}},[_vm._v(" В меню ")])],1):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }